


import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-scrolltop',
  template: `
    <button class="btn-scroll" (click)="totop()" *ngIf="show">
      <i class="fa fa-arrow-up"></i>
    </button>
  `,
  styles: [`
    .btn-scroll{
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 1px solid green;
      background: #89BF55;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      left: 10px;
      bottom: 10px;
      z-index: 9999;
      outline: none;
    }
  `]
})
export class ScrollTopComponent implements OnInit {
  constructor() { }

  ngOnInit() { }

  show = false;

  @HostListener("window:scroll", [])
  onWindowScroll(data) {
    this.show = window.pageYOffset > 15;
  }

  totop() {
    window.scrollTo(0, 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/component/core/scrolltop/scrolltop.component.ts